import { useGlobalDataStore } from '@stores/globalData/globalData.store'

import type { CustomDetector } from 'i18next-browser-languagedetector'

const serverLangDetector: CustomDetector = {
  name: 'server-lng',
  lookup(): string | string[] | undefined {
    const { serverData } = useGlobalDataStore.getState()
    return serverData?.login?.locale || serverData?.locale
  },
}

export default serverLangDetector
